import { Injectable } from '@angular/core';
import { TranslationService } from './translation.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorMessageExtractor {
  constructor(private translationService: TranslationService) {}


  extractErrorMessage(error: any, fallbackKey: string = 'ERROR_GENERAL'): string {
    const result = this.extractErrorRecursive(error, fallbackKey, 0);
    // If result is null, return the fallback translation
    return result === null ? this.translationService.getTranslation(fallbackKey) : result;
  }

  private extractErrorRecursive(error: any, fallbackKey: string, depth: number): string | null {
    // Prevent infinite recursion
    const MAX_DEPTH = 10;
    if (depth >= MAX_DEPTH || error == null) {
      return null;
    }

    if (typeof error === 'string') {
      return error;
    }

    // First, recursively check nested error property (go deep first)
    if (error.error) {
      const nestedResult = this.extractErrorRecursive(error.error, fallbackKey, depth + 1);
      // If we found something meaningful in the nested error, use it
      if (nestedResult !== null) {
        return nestedResult;
      }
    }

    // If nested search didn't find anything, check properties at current level
    // Check for translationKey (with translation)
    if (error.translationKey) {
      return this.translationService.getTranslation(error.translationKey);
    }

    // Check for message
    if (error.message && typeof error.message === 'string') {
      return error.message;
    }

    // Check for statusText
    if (error.statusText && typeof error.statusText === 'string') {
      return error.statusText;
    }

    return null;
  }

  translateErrorCode(errorCode: string): string {
    const knownErrorCodes = [
      'UNAUTHORIZED',
      'ERROR_GENERAL',
      'ERROR_CONNECTION',
      'ERROR_TIMEOUT',
      'ERROR_NOTFOUND',
      'ERROR_MISSINGREQUIREDFIELD',
      'NETWORK_ERROR',
      'BACK_OFF',
    ];

    if (knownErrorCodes.includes(errorCode?.toUpperCase())) {
      return this.translationService.getTranslation(errorCode);
    }

    return errorCode;
  }
}
